import { observer } from "mobx-react-lite";
import { NavItem } from "@menu/core/types";
import { AnalyticsType, getAnalyticTags, getDataTitleTag } from "@menu/core/lib";
import MenuContext, { DisplayItem } from "@menu/core/menu.context";
import { CountrySelector, LanguageSelector } from "@menu/components/shared";
import useMenuActions from "@menu/components/use-menu-actions";

type MobileParentNavProps = {
    onSelect: (e: any, link: NavItem) => void,
    context: MenuContext
}

const MobileParentNav = observer((props: MobileParentNavProps) => {
    const { onSelect, context } = props;

    const { showChannels } = useMenuActions(context);

    const links = context.site.navItems;

    if (!links || context.displayItem !== DisplayItem.MainNav) {
        return null;
    }

    const getAnalytics = (item: NavItem) => {
        return getAnalyticTags({
            component_name: "mobile_header",
            nav_item: AnalyticsType.topLevel,
            nav_text: item.title,
            target_page_url: context.siteUrl
        });
    }

    return (<nav className="mobile-parent-nav">
        <ul className="mobile-parent-links">
            {links.map((x, ix) =>
                <li key={ix}
                    {...getAnalytics(x)}
                    {...getDataTitleTag(x.title)}
                    onClick={(e) => onSelect(e, x)}>
                    {x.title}
                    <i className="icon-Arrow_right_thin" />
                </li>)}
        </ul>

        <span className={"mobile-selectors anim-" + (links.length + 1)}>
            <CountrySelector showFlag={true} isMobile={true} open={context.openCountrySelector} context={context} />

            {context.country.languages.length > 1 && <LanguageSelector isMobile={true} context={context} />}
        </span>

        {context.channels.length > 0 && <span className={"browse anim-" + (links.length + 2)}>
            <span>
                <i className="icon-site-switcher" onClick={() => showChannels(true)} />
                {context.dictionary.browseSites}
            </span>
        </span>}
    </nav>);
});

export default MobileParentNav;